import { IErrorDTO } from '@common-frontend-submodule/interfaces/common/ierror.interface';
import moment from 'moment';
import { ILocaleDTO } from '@common-frontend-submodule/interfaces/common/ilocale.interface';
import { Locale } from '@common-frontend-submodule/enums/locale/locale.enum';
import { IApiResponseGenericDTO } from '@common-frontend-submodule/interfaces/common/iapi-response.interface';
// import { Notify } from '../plugins/notify';
import { PeriodEnum } from '../enum/period.enum';
import { config } from '../boot/config';
import i18n from '../boot/i18n';
import { Notify } from '../plugins/notify';

export const Utils = {
  getDateRangeForPeriod(period: PeriodEnum) {
    const now = new Date();
    let startDate: Date | null = null;
    let endDate: Date | null = new Date();

    switch (period) {
      case PeriodEnum.YESTERDAY:
        startDate = new Date(now);
        startDate.setDate(now.getDate() - 1);
        startDate.setHours(0, 0, 0, 0);
        endDate.setDate(now.getDate() - 1);
        endDate.setHours(23, 59, 59, 999);
        break;
      case PeriodEnum.LAST_7_DAYS:
        startDate = new Date(now);
        startDate.setDate(now.getDate() - 7);
        break;
      case PeriodEnum.LAST_WEEK:
        startDate = new Date(now);
        const dayOfWeek = now.getDay();
        const lastSunday = new Date(now.setDate(now.getDate() - dayOfWeek - 7));
        lastSunday.setHours(0, 0, 0, 0);
        startDate = lastSunday;
        endDate = new Date(now.setDate(lastSunday.getDate() + 6));
        endDate.setHours(23, 59, 59, 999);
        break;
      case PeriodEnum.LAST_30_DAYS:
        startDate = new Date(now);
        startDate.setDate(now.getDate() - 30);
        break;
      case PeriodEnum.CURRENT_MONTH:
        startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        break;
      case PeriodEnum.LAST_MONTH:
        startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        break;
      case PeriodEnum.CURRENT_YEAR:
        startDate = new Date(now.getFullYear(), 0, 1);
        break;
      case PeriodEnum.LAST_YEAR:
        startDate = new Date(now.getFullYear() - 1, 0, 1);
        endDate = new Date(now.getFullYear() - 1, 11, 31, 23, 59, 59, 999);
        break;
      case PeriodEnum.ALL:
      default:
        return null;
    }

    if (startDate && endDate) {
      return `${startDate.toISOString()};${endDate.toISOString()}`;
    }

    return null;
  },

  enumToArray<T extends { [key: string]: string }>(enumObj: T): string[] {
    return Object.values(enumObj);
  },

  handleErrorResponse(error: IErrorDTO) {
    if (error?.errorCode) Notify.error(i18n.t(error.errorCode));
    if (error?.fieldsValidationErrors) {
      for (const fieldValidationError of error.fieldsValidationErrors) {
        Notify.error(fieldValidationError.name, 3, i18n.t(fieldValidationError.errorMessage));
      }
    }
    if (error?.paramsErrors) {
      for (const paramError of error.paramsErrors) {
        Notify.error(paramError.name, 3, i18n.t(paramError.value));
      }
    }
  },

  createResponse<T>(success: boolean, data: T | IErrorDTO | null): IApiResponseGenericDTO<T> {
    return data as IApiResponseGenericDTO<T>;
  },

  getLocaleValue(el: ILocaleDTO, locale: Locale) {
    return el[locale] || '';
  },

  rusToEng(value: string) {
    value = value.toLowerCase();
    let latin_value = '';
    const charset = [
      { k: 'а', l: 'a' },
      { k: 'б', l: 'b' },
      { k: 'в', l: 'v' },
      { k: 'г', l: 'g' },
      { k: 'д', l: 'd' },
      { k: 'е', l: 'e' },
      { k: 'ё', l: 'e' },
      { k: 'ж', l: 'zh' },
      { k: 'з', l: 'z' },
      { k: 'и', l: 'i' },
      { k: 'й', l: 'y' },
      { k: 'к', l: 'k' },
      { k: 'л', l: 'l' },
      { k: 'м', l: 'm' },
      { k: 'н', l: 'n' },
      { k: 'о', l: 'o' },
      { k: 'п', l: 'p' },
      { k: 'р', l: 'r' },
      { k: 'с', l: 's' },
      { k: 'т', l: 't' },
      { k: 'у', l: 'u' },
      { k: 'ф', l: 'f' },
      { k: 'х', l: 'h' },
      { k: 'ц', l: 'c' },
      { k: 'ч', l: 'ch' },
      { k: 'ш', l: 'sh' },
      { k: 'щ', l: 'shc' },
      { k: 'ь', l: '' },
      { k: 'ы', l: 'y' },
      { k: 'ъ', l: '' },
      { k: 'э', l: 'e' },
      { k: 'ю', l: 'yu' },
      { k: 'я', l: 'ya' }
    ];
    for (const char of value) {
      latin_value += charset.find((i) => i.k === char)?.l || '';
    }
    return latin_value;
  },

  getBase64(file: File, callback: (error: any, result?: any) => void) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      const result = {
        name: file.name,
        size: file.size,
        type: file.type,
        extension: file.name.split('.').pop(),
        base64: reader.result
      };
      callback(null, result);
    };
    reader.onerror = function (error) {
      callback(error);
    };
  },

  mapToLocaleValue(arr: any[], locale?: string) {
    return arr?.map((el) => ({
      id: el.id,
      name: locale ? el.name[locale] : el.name
    }));
  },

  mapToLocaleObject(obj: any, locale: string) {
    return {
      id: obj.id,
      name: obj.name[locale]
    };
  },

  convertToDate(date: string): Date {
    return moment(date).toDate();
  },

  formatDate(date: Date) {
    if (!(date instanceof Date) && typeof date === 'string') {
      date = new Date(date);
    }

    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return date;
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  },

  compareAndOrder(obj1: any, obj2: any) {
    const allKeys = Array.from(new Set([...Object.keys(obj1), ...Object.keys(obj2)]));
    const resultObj = {} as any;

    for (const key of allKeys) {
      resultObj[key] = key in obj2 ? obj2[key] : '';
    }

    const sortedObj = {} as any;
    const sortedKeys = Object.keys(resultObj).sort();
    for (const key of sortedKeys) {
      sortedObj[key] = resultObj[key];
    }

    return sortedObj;
  },

  checkEmail(email: string) {
    const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
    return emailPattern.test(email);
  },

  getFileUrl(filename: string) {
    return `${config.main.public_url}/${filename}`;
  }
};
